import {Component} from 'react'
import Cookies from 'js-cookie'
import {AiFillFire} from 'react-icons/ai'
import Loader from 'react-loader-spinner'
import CartContext from '../../context/CartContext'
import VideoCardTwo from '../VideoCardTwo'
import Header from '../Header'
import SideBar from '../SideBar'
import {
  HomeContainer,
  HomeSideContainer,
  SearchedVideoContainer,
  TrendingHeadContainer,
  TrendingLogo,
  VideosContainer,
  TrendingHead,
  ProductsLoaderContainer,
  HomeStickyContainer,
  Image,
  Heading,
  Desc,
  NavLink,
  Retry,
  NotFoundContainer,
} from './styledComponents'

const apiStatusConstant = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN_PROGRESS',
}

class TrendingRoute extends Component {
  state = {
    apiStatus: apiStatusConstant.initial,
    searchedVideos: [],
  }

  componentDidMount() {
    this.getSuggestionVideo()
  }

  getSuggestionVideo = async () => {
    this.setState({apiStatus: apiStatusConstant.inProgress})
    const jwtToken = Cookies.get('jwt_token')
    const apiUrl = 'https://apis.ccbp.in/videos/trending'
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }

    try {
      const response = await fetch(apiUrl, options)
      if (response.ok) {
        const fetchedData = await response.json()
        const updatedData = fetchedData.videos.map(each => ({
          id: each.id,
          title: each.title,
          channel: {
            profileImageUrl: each.channel.profile_image_url,
            name: each.channel.name,
          },
          thumbnailUrl: each.thumbnail_url,
          publishedAt: each.published_at,
          viewCount: each.view_count,
        }))
        this.setState({
          searchedVideos: updatedData,
          apiStatus: apiStatusConstant.success,
        })
      } else {
        this.setState({apiStatus: apiStatusConstant.failure})
      }
    } catch {
      this.setState({apiStatus: apiStatusConstant.failure})
    }
  }

  renderLoadingView = () => (
    <ProductsLoaderContainer data-testid="loader">
      <Loader type="ThreeDots" color="#0b69ff" height="50" width="50" />
    </ProductsLoaderContainer>
  )

  renderFailureView = () => (
    <NotFoundContainer>
      <Image
        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-light-theme-img.png"
        alt="failure view"
      />
      <Heading>Oops! Something Went Wrong</Heading>
      <Desc>
        We are having some trouble to complete your request. Please try again.
      </Desc>
      <NavLink to="#">
        <Retry onClick={this.getSuggestionVideo}>Retry</Retry>
      </NavLink>
    </NotFoundContainer>
  )

  renderTrendingVideos = () => {
    const {searchedVideos} = this.state

    return (
      <CartContext.Consumer>
        {value => {
          const {isDarkTheme} = value
          const bgColor = isDarkTheme ? '#0f0f0f' : '#f9f9f9'
          const textColor = isDarkTheme ? '#f9f9f9' : '#181818'

          return (
            <SearchedVideoContainer bgColor={bgColor}>
              <TrendingHeadContainer color={textColor} bgColor={bgColor}>
                <TrendingLogo>
                  <AiFillFire />
                </TrendingLogo>
                <TrendingHead color={textColor}>Trending</TrendingHead>
              </TrendingHeadContainer>

              <VideosContainer>
                {searchedVideos.map(each => (
                  <VideoCardTwo key={each.id} details={each} />
                ))}
              </VideosContainer>
            </SearchedVideoContainer>
          )
        }}
      </CartContext.Consumer>
    )
  }

  renderAllVideos = () => {
    const {apiStatus} = this.state

    switch (apiStatus) {
      case apiStatusConstant.success:
        return this.renderTrendingVideos()
      case apiStatusConstant.inProgress:
        return this.renderLoadingView()
      case apiStatusConstant.failure:
        return this.renderFailureView()
      default:
        return null
    }
  }

  render() {
    return (
      <CartContext.Consumer>
        {value => {
          const {isDarkTheme} = value
          const bgColor = isDarkTheme ? '#0f0f0f' : '#f9f9f9'

          return (
            <div>
              <Header />
              <HomeContainer data-testid="home" bgColor={bgColor}>
                <HomeStickyContainer>
                  <SideBar />
                </HomeStickyContainer>
                <HomeSideContainer bgColor={bgColor}>
                  {this.renderAllVideos()}
                </HomeSideContainer>
              </HomeContainer>
            </div>
          )
        }}
      </CartContext.Consumer>
    )
  }
}

export default TrendingRoute
